/** Values carried by the `m.call.intent` field of an RTC notification. */
export var ElementCallIntent;
(function (ElementCallIntent) {
    ElementCallIntent["StartCall"] = "start_call";
    ElementCallIntent["JoinExisting"] = "join_existing";
    ElementCallIntent["StartCallVoice"] = "start_call_voice";
    ElementCallIntent["JoinExistingVoice"] = "join_existing_voice";
    ElementCallIntent["StartCallDM"] = "start_call_dm";
    ElementCallIntent["JoinExistingDM"] = "join_existing_dm";
    ElementCallIntent["StartCallDMVoice"] = "start_call_dm_voice";
    ElementCallIntent["JoinExistingDMVoice"] = "join_existing_dm_voice";
})(ElementCallIntent || (ElementCallIntent = {}));
//# sourceMappingURL=elementCallIntent.js.map